import { getUserData, loginUserWithWallet } from 'APIs/AuthApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Footer from 'components/organisms/Footer/NoneFooter';
import { ACCESS_TOKEN } from 'constant';
import { login, selectAuth, setWallet } from 'features/auth/authSlice';
import { useEffect } from 'react';
import Media from 'react-media';
import { useNavigate } from 'react-router-dom';
import DesktopBody from 'views/DesktopViews/SignInPage';
import Body from 'views/MobileViews/SignInPage';

const SignIn = () => {
  // const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const authState = useAppSelector(selectAuth);

  // const [connectedWallets, setConnectedWallets] = useState<string[] | null>(null);

  const loginIfWalletExists = async (walletAddress?: string) => {
    const loginRes = await loginUserWithWallet({
      walletAddress: walletAddress,
    });

    if (!(loginRes && loginRes.access_token)) return false;

    localStorage.setItem(ACCESS_TOKEN, loginRes.access_token);

    const userData = await getUserData();

    if (userData) {
      dispatch(login({ ...userData }));
    }
    return true;
  };

  const handleConnectWallet = async () => {
    if (window.ethereum) {
      window.ethereum
        .request({ method: 'eth_requestAccounts' })
        .then(async (res: any) => {
          // Return the address of the wallet
          if (res.length > 0) {
            const exists = await loginIfWalletExists(res[0]);
            if (!exists) {
              dispatch(
                setWallet({
                  walletAddress: res[0],
                })
              );
            }
          }
        });
    } else {
      alert('install metamask extension!!');
    }
  };

  useEffect(() => {
    if (authState.authenticated) {
      navigate('/');
    } else if (authState.walletAddress && !authState.id) {
      navigate('/signup');
    }
  }, [authState, navigate]);

  return (
    <>
      <Media query="(max-width: 599px)">
        {matches =>
          matches ? (
            <Body handleConnectWallet={handleConnectWallet} />
          ) : (
            <DesktopBody handleConnectWallet={handleConnectWallet} />
          )
        }
      </Media>
      <Footer />
    </>
  );
};

export default SignIn;
